import { IPaginationTableActionDefinition } from './types/ipagination-table-action-definition';

export class PaginationTableActionDefinition {
	constructor(
		/** The function that will be called when the user clicks on the button */
		public action: (ids: any[]) => void,
		/** Display name of the action */
		public name: string,
	) {}

	/** Is the action disabled */
	public disabled: boolean = false;
	/** Is the action hidden */
	public visible: boolean = true;
	/** The minimum selection count required for the action to be clickable */
	public selectedNoLessThan: number = 0;
	/** The maximum selection count for the action to be clickable */
	public selectedNoMoreThan: number = Number.MAX_SAFE_INTEGER;

	/** Builds a single action definition */
	public static Create(
		input: IPaginationTableActionDefinition,
	): PaginationTableActionDefinition {
		const result = new PaginationTableActionDefinition(
			input.action,
			input.name,
		);

		for (const key in input) {
			if (input.hasOwnProperty(key)) {
				result[key] = input[key];
			}
		}

		return result;
	}

	/** Builds multiple action definitions */
	public static CreateMany(
		input: IPaginationTableActionDefinition[],
	): PaginationTableActionDefinition[] {
		const mapFunc = function (x: IPaginationTableActionDefinition) {
			return PaginationTableActionDefinition.Create(x);
		};
		return input.map(mapFunc);
	}

	/** Returns the message that the user should currently see */
	public hoverMessage: (disabled: boolean, selection: number) => string | null =
		function () {
			return null;
		};
}

export type PaginationTableActionAdditional =
	| { type: 'header'; name: string }
	| { type: 'divider' };
